import React, { useEffect, useRef, useState } from 'react'
import './admin-data.styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faCertificate, faCheckDouble, faDownload, faF, faFilter, faFlagCheckered, faInfo, faInfoCircle, faLineChart, faPen, faPenToSquare, faPlus, faRibbon, faShoppingCart, faTrash, faTrophy, faUsers, faUsersBetweenLines } from '@fortawesome/free-solid-svg-icons'
import { getCompiledDataFromDb } from '@/utils/getDataFromDb'
import DataCard from './data-card.component'
import LineChart from './line-chart.component'
import { format, setWeek } from 'date-fns'
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component'
import { ModalAlert, ModalConfirm } from '@/components/SHARED/modal/modal.component'
import EditDataModal from './edit-data-modal.component'
import { useNavigate } from 'react-router-dom'
import DataFilters from './data-filters.component'
import DataDownloadModal from './data-download-modal.component'
import { properCase } from '@/utils/properCase'
import { createPurchaseDataPoint } from '@/utils/create-purchase-data-point'

const AdminData = ({
  users,
  mcList,
  activityLogs,
  nfeRegs
}) => {

  const [logsForChart, setLogsForChart] = useState(null);
  const [tenDays, setTenDays] = useState([]);
  const [dataToDisplay, setDataToDisplay] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGE_SIZE = 20;
  const [activeUsers, setActiveUsers] = useState(0);
  const [dataToEdit, setDataToEdit] = useState(null);
  const [filter, setFilter] = useState({});
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [clear, setClear] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [graphHeight, setGraphHeight] = useState(0);
  const dataRef = useRef();
  const approveRef = useRef();
  const filterRef = useRef();
  const dataListenerRef = useRef(null);
  const purchaseDebounceRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    const boxheight = document.getElementById('graph-box').offsetHeight;
    setGraphHeight(boxheight - 57);

    return () => {
      clearTimeout(timeout);
    }
  }, [])

  // useEffect(() => {
  //     if (!nfeRegs) return;
  //     console.log(nfeRegs);
  //     let arr = [];
  //     const tenDaysAgo = new Date();
  //     tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  //     tenDaysAgo.setHours(0, 1, 0, 0); // Set to 12:01 AM
  //     for (let mc of Object.values(nfeRegs)) {
  //         for (let r of Object.values(mc)) {
  //             const ts = new Date(r['reg_add_date']).getTime();
  //             if (ts > tenDaysAgo.getTime()) {
  //                 arr.push(r);
  //             }
  //         }
  //     }
  //     setBrokedownRegs(arr);
  // }, [nfeRegs])

  useEffect(() => {
    if (!activityLogs) return;
    setLogsForChart(Object.values(activityLogs));
    setActiveUsers([...new Set(Object.values(activityLogs).map(d => d.user))].length);
  }, [activityLogs])

  useEffect(() => {
    // getCompiledData();
    // getTenDaysData();
    // getCompletedCount();
    // getPurchasedCount();
    getFilteredData();
  }, [users, nfeRegs])

  // useEffect(() => {
  //     console.log(filter);
  //     if (Object.values(filter).length === 0 && users) {
  //         getTenDaysData();
  //         return;
  //     }
  // }, [filter])

  function getFilteredData() {
    console.log('getting filtered data')
    console.log(filter);
    if (Object.values(filter).length === 0 && users) {
      getTenDaysData();
      return;
    }
    if (dataListenerRef.current) dataListenerRef.current();
    dataRef.current = {};
    setCurrentPage(0);
    setDataToDisplay(Object.values(dataRef.current));
    let filterObj = { ...filterRef.current };
    if (filterObj.type && filterObj.type === 'purchase-completed') {
      addPurchaseData();
      return;
    }
    filterObj.callback = callback;
    filterObj.handleListener = handleListener;
    function callback(data) {
      let tempData = { ...dataRef.current };
      if (data.deleted) {
        delete tempData[data.id];
        dataRef.current = { ...tempData };
      } else {
        dataRef.current = {
          ...dataRef.current,
          ...{ [data.id]: data }
        }
      }
      if (purchaseDebounceRef.current) clearTimeout(purchaseDebounceRef.current);
      purchaseDebounceRef.current = setTimeout(() => {
        addPurchaseData();
        setLoading(false);
      }, 50);
    }
    function handleListener(unsub) {
      dataListenerRef.current = unsub;
    }
    getCompiledDataFromDb(filterObj);
  }

  function addPurchaseData(startDate) {
    let newArr = [];
    let filterObj = { ...filterRef.current };
    if (filterObj.type && filterObj.type !== 'purchase-completed') {
      setDataToDisplay(Object.values(dataRef.current));
      return;
    }
    for (let mc_key of Object.keys(nfeRegs)) {
      const regs = nfeRegs[mc_key];
      if (
        filterObj.mc_key &&
        filterObj.mc_key !== mc_key
      ) continue;
      for (let cst_key of Object.keys(regs)) {
        const purchase = regs[cst_key];
        const ts = new Date(purchase['reg_add_date']).getTime();
        if (
          filterObj.cst_key &&
          filterObj.cst_key !== cst_key
        ) continue;
        if (
          (
            filterObj.startDate &&
            filterObj.startDate > ts
          ) ||
          (
            startDate &&
            startDate > ts
          )
        ) continue;
        if (
          filterObj.endDate &&
          filterObj.endDate < ts
        ) continue;
        if (
          filterObj.state &&
          (
            !users[cst_key] ||
            users[cst_key].state !== filterObj.state
          )
        ) continue;

        const obj = createPurchaseDataPoint(
          { 'add_date': ts },
          users[cst_key],
          mcList[mc_key]
        )
        // console.log(obj);
        if (!obj) continue;
        let tempData = { ...dataRef.current }
        if (Object.values(tempData).filter(t => t.progressId === obj.progressId).length !== 0) continue;
        dataRef.current = {
          ...dataRef.current,
          ...{ [obj.id]: obj }
        }
      }
    }
    setDataToDisplay(Object.values(dataRef.current).filter(t => !t.deleted));
    if (startDate) {
      setTenDays(Object.values(dataRef.current).filter(t => !t.deleted));
    }
  }

  function getTenDaysData() {
    setLoading(true);

    if (dataListenerRef.current) dataListenerRef.current();
    dataRef.current = {};
    setDataToDisplay(Object.values(dataRef.current));
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
    tenDaysAgo.setHours(0, 1, 0, 0); // Set to 12:01 AM
    getCompiledDataFromDb({
      'startDate': tenDaysAgo.getTime(),
      'callback': callback,
      'handleListener': handleListener,
    });
    function callback(data) {
      dataRef.current = {
        ...dataRef.current,
        ...{ [data.id]: data }
      }
      if (purchaseDebounceRef.current) clearTimeout(purchaseDebounceRef.current);
      purchaseDebounceRef.current = setTimeout(() => {
        addPurchaseData(tenDaysAgo.getTime());
        setLoading(false);
      }, 50);
    }
    function handleListener(unsub) {
      dataListenerRef.current = unsub;
    }
  }

  function displayFilteredMcs(e) {
    filterRef.current = {};
    setFilter(filterRef.current);
    setClear(true);
    setCurrentPage(0);
    if (dataListenerRef.current) dataListenerRef.current();
    setDataToDisplay(
      Object.values(tenDays)
        .filter(t => t.type === e)
    )
  }

  function changeFilterOption(key, value) {
    let tempFilter = { ...filterRef.current };
    if (!value) {
      delete tempFilter[key];
    } else {
      tempFilter = {
        ...tempFilter,
        ...{ [key]: value }
      }
    }
    filterRef.current = { ...tempFilter }
    setFilter(filterRef.current);
  }

  function resetData() {
    filterRef.current = {};
    setFilter(filterRef.current);
    setClear(true);
    setCurrentPage(0);
    getTenDaysData();
  }

  return (
    <div className='admin-data'>
      <div className='section-title with-icon'>
        Micro-Credential Data
        <div className='multiple-icons'>
          {
            (users && mcList) &&
            <>
              <button
                className='g-button text'
                onClick={() => setShowDownloadModal(true)}>
                <FontAwesomeIcon
                  icon={faDownload}
                  className='icon'
                  title='Download Data' />
              </button>

            </>
          }
        </div>
      </div>
      <div className="g-space-1"></div>
      <div className='data-page-content'>
        <div className='data-page-grid g-card'>
          <div className='card-title'>10-Day User Data Summary</div>
          <div className='data-card-div user-count'>
            <DataCard
              icon={faLineChart}
              data={logsForChart ? Object.values(logsForChart).length.toLocaleString() : []}
              text='Total Activity'
              onclick={() => navigate('/admin/activity')} />
          </div>

          <div className='data-card-div active-count'>
            <DataCard
              icon={faUsers}
              data={activeUsers}
              text='Active Users'
              onclick={() => navigate('/admin/users')} />
          </div>
          <div className='data-card-div started-count'>
            <DataCard
              icon={faFlagCheckered}
              data={tenDays ? Object.values(tenDays).filter(l => l.type === 'materials-accepted').length.toLocaleString() : 0}
              text='MCs Started'
              onclick={() => displayFilteredMcs('materials-accepted')} />
          </div>
          <div className='data-card-div precheck-count'>
            <DataCard
              icon={faCheckDouble}
              data={tenDays ? Object.values(tenDays).filter(l => l.type === 'precheck-approved').length.toLocaleString() : 0}
              text='Prechecks Approved'
              onclick={() => displayFilteredMcs('precheck-approved')} />
          </div>
          <div className='data-card-div purchased-count'>
            <DataCard
              icon={faShoppingCart}
              data={tenDays ? Object.values(tenDays).filter(l => l.type === 'purchase-completed').length.toLocaleString() : 0}
              text='Purchased MCs'
              onclick={() => displayFilteredMcs('purchase-completed')} />
          </div>
          <div className='data-card-div completed-count'>
            <DataCard
              icon={faTrophy}
              data={tenDays ? Object.values(tenDays).filter(l => l.type === 'portfolio-approved').length.toLocaleString() : 0}
              text='Completed MCs'
              onclick={() => displayFilteredMcs('portfolio-approved')} />
          </div>
          <div className='ten-days g-list-item' id='graph-box' >
            <div className='chart-text'>Daily Activity Breakdown</div>
            {
              (logsForChart) &&
              <LineChart
                recentActivity={logsForChart}
                chartHeight={graphHeight} />
            }
          </div>
        </div>
        <div className="g-space-2"></div>
        <div className='card-title'>
          User Data List
          <button
            className='g-button med-btn'
            onClick={() => setDataToEdit({})}>
            Add Data Point
            <FontAwesomeIcon icon={faPlus} className='icon' />
          </button>
        </div>
        <div className="g-space-1"></div>
        <div className="user-data-grid">
          <div className="filter-col">
            <DataFilters
              users={users}
              mcList={mcList}
              filter={filter}
              changeFilterOption={changeFilterOption}
              clear={clear}
              setClear={setClear} />
            <div className="g-space-0-5"></div>
            <div className='buttons stack'>
              <button
                className='g-button med-btn primary'
                onClick={() => getFilteredData()}>
                Get Filtered Data
              </button>
              <button
                className='g-button small-btn'
                onClick={() => resetData()}>
                Clear Filter
                {/* <div className=' stacked-icons'>
                                    <FontAwesomeIcon icon={faFilter} />
                                    <FontAwesomeIcon icon={faBan} />
                                </div> */}
              </button>
            </div>
          </div>
          {/* <div className="g-space-1"></div> */}
          <div className='data-list'>
            <table className='g-table'>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User</th>
                  <th>State</th>
                  <th>MC</th>
                  <th>Action</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  (loading)
                    ?
                    <tr>
                      <td colSpan="5">
                        <ThreeDotsLoader />
                      </td>
                    </tr>
                    :
                    (dataToDisplay.length > 0 && mcList && users)
                      ?
                      dataToDisplay
                        .sort((a, b) => a.ts < b.ts ? 1 : -1)
                        .slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE)
                        .map((a, i) => {
                          // console.log(a);
                          const user = users[a.cst_key];
                          const mcData = mcList[a.mc_key];
                          if (!user) {
                            console.log(`missing user: ${a.cst_key}`);
                            return;
                          }
                          if (!mcData) {
                            console.log(`missing MC: ${a.mc_key}`);
                            return;
                          }
                          return (
                            <tr key={a.id}>
                              <td>{a.ts ? format(new Date(a.ts), "Pp") : 'no date'}</td>
                              <td>{users[a.cst_key].fName} {users[a.cst_key].lName}</td>
                              <td>{users[a.cst_key].state}</td>
                              <td>{mcList[a.mc_key].name}</td>
                              <td>

                                {properCase(a.type.replace('-', ' '))}
                              </td>
                              <td>
                                <div className='notice'>
                                  {
                                    a.ts_created
                                      ? <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        title={`Created on ${format(new Date(a.ts_created), "Pp")} by ${users[a.createdBy].lName} `} />
                                      : ''
                                  }
                                  {
                                    (Object.keys(a).filter(k => k.includes('edit_')).length > 0)
                                      ? <FontAwesomeIcon
                                        icon={faPenToSquare}
                                        title={`Last edited on ${format(new Date(a.ts), "Pp")}`} />
                                      : ''
                                  }
                                </div>
                              </td>
                              <td>
                                <button
                                  className='g-button small-btn'
                                  onClick={() => setDataToEdit(a)}>
                                  <FontAwesomeIcon icon={faPen} />
                                </button>
                              </td>
                            </tr>
                          )
                        })
                      :
                      <tr>
                        <td colSpan="5">
                          {
                            (Object.values(filter).length > 0)
                              ?
                              <span>No data in the last 10 days...</span>
                              :
                              <span>No filtered data available...</span>
                          }
                        </td>
                      </tr>
                }
              </tbody>
            </table>
            {
              dataToDisplay.length > PAGE_SIZE &&
              <div className='pagination-controls'>
                <button
                  className='g-button small-btn'
                  disabled={currentPage === 0}
                  onClick={() => setCurrentPage(p => p - 1)}>
                  Previous
                </button>
                <span className='pagination-info'>
                  {currentPage * PAGE_SIZE + 1}–{Math.min((currentPage + 1) * PAGE_SIZE, dataToDisplay.length)} of {dataToDisplay.length}
                </span>
                <button
                  className='g-button small-btn'
                  disabled={(currentPage + 1) * PAGE_SIZE >= dataToDisplay.length}
                  onClick={() => setCurrentPage(p => p + 1)}>
                  Next
                </button>
              </div>
            }
          </div>
        </div>
      </div>
      <EditDataModal
        show={dataToEdit}
        cancel={() => setDataToEdit(null)}
        dataPoint={dataToEdit}
        users={users}
        mcList={mcList} />
      <DataDownloadModal
        show={showDownloadModal}
        cancel={() => setShowDownloadModal(false)}
        users={users}
        mcList={mcList}
        nfeRegs={nfeRegs} />
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default AdminData